import { render, staticRenderFns } from "./InvolvementBody.vue?vue&type=template&id=0793ec74&"
import script from "./InvolvementBody.vue?vue&type=script&lang=js&"
export * from "./InvolvementBody.vue?vue&type=script&lang=js&"
import style0 from "./InvolvementBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports